// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expand-btn{display:flex;width:100%;justify-content:space-between;padding-bottom:15px;border-bottom:1px solid #f2f1f4}.expand-btn__left-side{display:flex;gap:10px;align-items:center}", ""]);
// Exports
module.exports = exports;
